// extracted by mini-css-extract-plugin
export default {"note":"ReplayDelayNote_note__PKLYF","icon":"ReplayDelayNote_icon__jtJMC","text":"ReplayDelayNote_text__-xM4d"};